import React from 'react';

const PostingOptionsSection: React.FC = () => {
    return (
        <section style={{
            background: '#FFFFFF',
            padding: '120px 24px',
        }}>
            <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
                <div style={{ textAlign: 'center', marginBottom: '64px' }}>
                    <h2 style={{
                        fontSize: 'clamp(32px, 5vw, 48px)',
                        fontWeight: 500,
                        color: '#000000',
                        marginBottom: '16px',
                        letterSpacing: '-0.02em',
                    }}>
                        Two ways to post your comments
                    </h2>
                    <p style={{
                        fontSize: '18px',
                        color: '#333333',
                    }}>
                        Choose the workflow that fits your comfort level
                    </p>
                </div>

                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
                    gap: '24px',
                    marginBottom: '40px',
                }}>
                    {/* Manual Posting Card */}
                    <div style={{
                        background: '#FFFFFF',
                        padding: '48px 32px',
                        borderRadius: '8px',
                        border: '1px solid #E5E5E5',
                    }}>
                        <div style={{
                            width: '64px',
                            height: '64px',
                            borderRadius: '8px',
                            background: '#7C3AED',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginBottom: '24px',
                            color: '#FFFFFF',
                        }}>
                            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                                <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                            </svg>
                        </div>
                        <h3 style={{
                            fontSize: '20px',
                            fontWeight: 600,
                            color: '#000000',
                            marginBottom: '16px',
                        }}>
                            Manual Posting
                        </h3>
                        <ol style={{
                            padding: '0 0 0 20px',
                            margin: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '12px',
                        }}>
                            <li style={{ fontSize: '15px', color: '#444444', lineHeight: 1.6 }}>
                                Tap a comment from your approved queue
                            </li>
                            <li style={{ fontSize: '15px', color: '#444444', lineHeight: 1.6 }}>
                                Instagram opens with the post
                            </li>
                            <li style={{ fontSize: '15px', color: '#444444', lineHeight: 1.6 }}>
                                Comment is copied to your clipboard
                            </li>
                            <li style={{ fontSize: '15px', color: '#444444', lineHeight: 1.6 }}>
                                Paste and post — done!
                            </li>
                        </ol>
                    </div>

                    {/* Auto Posting Card */}
                    <div style={{
                        background: '#FFFFFF',
                        padding: '48px 32px',
                        borderRadius: '8px',
                        border: '1px solid #E5E5E5',
                    }}>
                        <div style={{
                            width: '64px',
                            height: '64px',
                            borderRadius: '8px',
                            background: '#10B981',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginBottom: '24px',
                            color: '#FFFFFF',
                        }}>
                            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
                            </svg>
                        </div>
                        <h3 style={{
                            fontSize: '20px',
                            fontWeight: 600,
                            color: '#000000',
                            marginBottom: '16px',
                        }}>
                            Auto Posting
                        </h3>
                        <ol style={{
                            padding: '0 0 0 20px',
                            margin: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '12px',
                        }}>
                            <li style={{ fontSize: '15px', color: '#444444', lineHeight: 1.6 }}>
                                Approved comments go into a queue
                            </li>
                            <li style={{ fontSize: '15px', color: '#444444', lineHeight: 1.6 }}>
                                A secure VM launches in the cloud
                            </li>
                            <li style={{ fontSize: '15px', color: '#444444', lineHeight: 1.6 }}>
                                Logs into Instagram on your behalf
                            </li>
                            <li style={{ fontSize: '15px', color: '#444444', lineHeight: 1.6 }}>
                                Posts comments automatically at safe intervals
                            </li>
                        </ol>
                    </div>
                </div>

                {/* Trust message */}
                <div style={{
                    textAlign: 'center',
                    padding: '24px',
                    background: '#F7F7F7',
                    borderRadius: '8px',
                    border: '1px solid #E5E5E5',
                }}>
                    <p style={{
                        fontSize: '15px',
                        color: '#444444',
                        margin: 0,
                        lineHeight: 1.6,
                    }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#7C3AED" strokeWidth="2" style={{ verticalAlign: 'middle', marginRight: '8px' }}>
                            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                        </svg>
                        Don't want to share your credentials? <strong>Manual posting is equally effective.</strong> You stay in full control.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default PostingOptionsSection;
